import _defineProperty from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'led_mng',
  data: function data() {
    // 校验输入JSON格式
    var validateConfValue = function validateConfValue(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入配置值'));
      } else {
        try {
          JSON.parse(value);
        } catch (e) {
          callback(new Error('输入的不是有效的JSON格式'));
        }
      }
      callback();
    };
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: 'LED',
        addFunName: 'ledAdd',
        modifyFunName: 'ledModify',
        queryFunName: 'ledQuery',
        detailFunName: 'ledDetail',
        delFunName: 'ledDel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        model: 'Yi_Lu',
        offlineThreshold: 600
      },
      rules: {
        id: [{
          required: true,
          message: '请输入设备编号',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请选择所属养殖区域',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }],
        model: [{
          required: true,
          message: '请选择设备型号',
          trigger: 'blur'
        }],
        textTemplate: [{
          required: true,
          message: '请输入文字模版',
          trigger: 'blur'
        }],
        refreshInterval: [{
          required: true,
          message: '请输入刷新间隔',
          trigger: 'blur'
        }],
        confValue: [{
          validator: validateConfValue,
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '130px',
      emptyFormData: {},
      lab_show: false,
      area_show: false
      // 百度地图
      ,
      markLocation: {},
      mapCenter: {
        lng: 104.0,
        lat: 35.0
      },
      inputValue: '',
      searchObj: ''
    };
  },
  components: {
    labSel: function labSel() {
      return import('../../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../../org/lab_area_sel.vue');
    }
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  watch: {
    searchObj: function searchObj(e) {
      var _this = this;
      // console.log('searchObj',e)
      if (e) {
        this.inputValue = '';
        this.myGeo = new BMap.Geocoder(); // 创建地址解析器的实例
        this.myGeo.getPoint(e, function (point) {
          // console.log('point',point)
          if (point) {
            _this.mapCenter = _this.markLocation = point;
            _this.$set(_this.formData, 'lat', point.lat);
            _this.$set(_this.formData, 'lng', point.lng);
            // map.centerAndZoom(point, 16);
            // map.addOverlay(new BMapGL.Marker(point, {title: e}))
          } else {
            alert('您选择的地址没有解析到结果！');
          }
        });
      }
    },
    editDialogShow: function editDialogShow(to) {
      if (!to) {
        this.mapCenter = {};
        this.markLocation = {};
      }
    }
  },
  methods: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'edit':
          // 预览
          this.edit(command.row);
          break;
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  var listImage;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        listImage = _context.sent;
                        _this2.$set(_this2.formData, 'listImage', listImage);
                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.listImage);
    },
    removeFile: function removeFile() {
      this.formData.listImage = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.initFormData(this.emptyFormData);
      this.mapCenter = {
        lng: 104.0,
        lat: 35.0
      };
      this.markLocation = {};
      this.editDialogShow = true;
    },
    edit: function edit(data) {
      if (data.lat && data.lng) {
        this.mapCenter = {
          lat: data.lat,
          lng: data.lng
        };
        this.markLocation = {
          lat: data.lat,
          lng: data.lng
        };
      }
      this.initFormData(data);
      this.editDialogTitle = this.pageConfig.editPageName + '维护';
      this.editDialogShow = true;
    },
    getLocation: function getLocation(e) {
      this.markLocation = e.point;
      this.$set(this.formData, 'lat', e.point.lat);
      this.$set(this.formData, 'lng', e.point.lng);
    },
    debug: function debug(_ref3) {
      var _this3 = this;
      var id = _ref3.id;
      this.$prompt('请输入调试内容', '调试', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function (_ref4) {
        var value = _ref4.value;
        _this3.$api['ledDebug'](id, {
          content: value
        }).then(function (res) {
          if (res.data) {
            _this3.query();
            _this3.$message.success('操作成功');
          } else {
            _this3.$message.error(res.msg);
          }
        });
      }).catch(function () {});
    },
    simulate: function simulate(_ref5) {
      var _this4 = this;
      var id = _ref5.id;
      this.$api['ledSimulate'](id).then(function (res) {
        if (res.data) {
          _this4.query();
          _this4.$message.success('操作成功');
        } else {
          _this4.$message.error(res.msg);
        }
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'areaId', '');
        this.$set(this.formData, 'areaName', '');
      }
      this.lab_show = false;
    } // 选择养殖区域
    ,
    areaClick: function areaClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业！');
        return;
      }
      this.area_show = true;
    },
    areaSel: function areaSel(data) {
      if (data) {
        this.$set(this.formData, 'areaId', data.id);
        this.$set(this.formData, 'areaName', data.name);
      }
      this.area_show = false;
    },
    del: function del(_ref6) {
      var _this5 = this;
      var id = _ref6.id;
      this.$confirm('确定要删除吗').then(function () {
        _this5.$api[_this5.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this5.$message.success('删除成功');
            _this5.query();
          } else {
            _this5.$message.error('删除失败');
          }
        });
      });
    },
    param: function param(course) {
      this.$emit('child-go', course, 'ledParam');
    },
    query: function query() {
      var _this6 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this6.tableData = res.data || [];
        _this6.totalCount = res.count;
        _this6.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this7 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this7.formData.createTime) {
            _this7.$api[_this7.pageConfig.modifyFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('编辑成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('编辑失败');
              }
            });
          } else {
            _this7.$api[_this7.pageConfig.addFunName](_this7.saveFormDataProcess(_this7.formData)).then(function (res) {
              if (res.data) {
                _this7.$message.success('新增成功');
                _this7.initFormData(_this7.emptyFormData);
                _this7.editDialogShow = false;
                _this7.query();
              } else {
                _this7.$message.error('新增失败');
              }
            });
          }
        }
      });
    }
  }, "beforeFileUpload", function beforeFileUpload(file) {
    var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
    if (!isImage) {
      this.$message.error('文件必须是图片格式');
    }
    var isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      this.$message.error('图片大小不超过5M！');
    }
    return isImage && isLt5M;
  }), "upload", function upload(_ref7) {
    var _this8 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var file;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            file = _ref7.file;
            _this8.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                var listImage;
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _this8.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                    case 2:
                      listImage = _context3.sent;
                      _this8.$set(_this8.formData, 'listImage', listImage);
                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x2) {
                return _ref8.apply(this, arguments);
              };
            }());
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }), "previewFile", function previewFile() {
    window.open(this.formData.listImage);
  }), "removeFile", function removeFile() {
    this.formData.listImage = '';
  }), "closeEditDialogShow", function closeEditDialogShow() {
    this.editDialogTitle = '';
    this.editDialogShow = false;
    this.initFormData(this.emptyFormData);
  }), "search", function search() {
    this.searchForm.page = 1;
    this.query();
  }), "pageChange", function pageChange(page) {
    this.searchForm.page = page;
    this.query();
  }), "sizeChange", function sizeChange(limit) {
    this.searchForm.page = 1;
    this.searchForm.limit = limit;
    this.query();
  }), "sortChange", function sortChange(column) {
    this.searchForm.page = 1;
    this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
    this.query();
  })
};